import copyToClipboard from '@/components/base-components/services/copy-to-clipboard';

function setActive(el, active) {
    el.classList.toggle('underline', active);
}

function addListeners(el) {
    el.activateCtrlKeyHandler = (event) => {
        setActive(el, event.ctrlKey || event.metaKey);
    };

    el.copyToClipboardHandler = (event) => {
        if (!event.ctrlKey && !event.metaKey) return;

        copyToClipboard(
            el.copyDirectiveBinding.value,
            !el.copyDirectiveBinding.modifiers?.noMessage,
        );

        event.stopPropagation();
        event.preventDefault();
    };

    el.addEventListener('click', el.copyToClipboardHandler);
    window.addEventListener('keydown', el.activateCtrlKeyHandler);
    window.addEventListener('keyup', el.activateCtrlKeyHandler);
    window.addEventListener('blur', el.activateCtrlKeyHandler);
}

function removeListeners(el) {
    el.removeEventListener('click', el.copyToClipboardHandler);
    window.removeEventListener('keydown', el.activateCtrlKeyHandler);
    window.removeEventListener('keyup', el.activateCtrlKeyHandler);
    window.removeEventListener('blur', el.activateCtrlKeyHandler);
}

const directive = {
    bind(el, binding) {
        el.copyDirectiveBinding = binding;

        addListeners(el);
    },

    update(el, binding) {
        el.copyDirectiveBinding = binding;
    },

    unbind(el) {
        removeListeners(el);
        setActive(el, false);

        delete el.copyDirectiveBinding;
        delete el.activateCtrlKeyHandler;
        delete el.copyToClipboardHandler;
    },
};

export default directive;
